import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';
import { STATUS_ANDAMENTO } from '../services/protocoloService';

const LegendBox = styled.div`
  background: ${colors.white};
  border: 1px solid #eef2f6;
  border-radius: 16px;
  padding: 16px 20px;
  margin-bottom: 24px;
`;

const LegendTitle = styled.p`
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  margin: 0 0 12px 0;
`;

const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 0.85rem;
  color: #5a6e7c;
  line-height: 1.4;
`;

const LegendDot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: ${props => props.$cor};
  flex-shrink: 0;
  align-self: center;
`;

const LegendLabel = styled.strong`
  color: #1a2c3e;
  font-weight: 600;
  margin-right: 4px;
  white-space: nowrap;
`;

const StatusLegend = () => (
  <LegendBox>
    <LegendTitle>O que significa cada status</LegendTitle>
    <LegendList>
      {STATUS_ANDAMENTO.map((status) => (
        <LegendItem key={status.label}>
          <LegendDot $cor={status.cor} />
          <span>
            <LegendLabel>{status.label}:</LegendLabel>
            {status.descricao}
          </span>
        </LegendItem>
      ))}
    </LegendList>
  </LegendBox>
);

export default StatusLegend;
